var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('all',{attrs:{"active-list":_vm.activeList}})],1),_c('b-col',{attrs:{"md":"6"}},[_c('executiveDocument',{attrs:{"active-list":_vm.activeList}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }